import { render, staticRenderFns } from "./DigiBoardList.vue?vue&type=template&id=0579f402&scoped=true"
import script from "./DigiBoardList.vue?vue&type=script&lang=js"
export * from "./DigiBoardList.vue?vue&type=script&lang=js"
import style0 from "./DigiBoardList.vue?vue&type=style&index=0&id=0579f402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0579f402",
  null
  
)

export default component.exports